// import dayjs from "@/plugins/dayjs";
// import createUUID from "@/helpers/uuid";
import axios from "axios";
// const URL = "http://192.168.0.105:3001/automations/";
const URL = process.env.VUE_APP_API + "automations/";

const getResponsePayload = (responseData) => {
  if (
    responseData &&
    typeof responseData === "object" &&
    "data" in responseData &&
    responseData.data
  ) {
    return responseData.data;
  }

  return responseData;
};

const extractAutomationUuid = (value) => {
  if (!value) {
    return null;
  }

  if (typeof value === "string") {
    return value;
  }

  if (typeof value === "object") {
    if (typeof value.uuid === "string") {
      return value.uuid;
    }

    if (value.auto && typeof value.auto.uuid === "string") {
      return value.auto.uuid;
    }

    if (value.data) {
      return extractAutomationUuid(value.data);
    }
  }

  return null;
};

/**
 * Initial state
 */
export const state = {
  automations: {},
};

/**
 * Mutations
 */
export const mutations = {
  ["SET_AUTOMATIONS"](state, automations) {
    // console.log("Automations11111111111: ", state.automations, automations);
    const nextState = {};

    if (Object.keys(automations).length > 0) {
      for (let i = 0; i < Object.values(automations).length; i++) {
        let automation = Object.values(automations)[i];
        let delay_time = automation.delay_time;
        let ifs = [];
        let thens = [];
        let ends = [];

        // console.log("Object.keys(automations): ", Object.keys(automations));
        Object.keys(automation.data.ifs).forEach((ifType) => {
          if (ifType == "device_ifs") {
            for (let i = 0; i < automation.data.ifs[ifType].length; i++) {
              const deviceIf = automation.data.ifs[ifType][i];
              let ifObj = {
                if_sensor: deviceIf.device,
                if_sensorDevice: deviceIf.parameter,
                state: deviceIf.compare_type,
                to_state:
                  deviceIf.compare_type == "toDeviceTemp"
                    ? deviceIf.to_device
                    : deviceIf.compare_type == "staticTemp"
                    ? deviceIf.static_parameter_value
                    : null,
                if_action: deviceIf.operator,
              };
              ifs.push({ device: ifObj });
            }
          } else if (ifType == "connection_ifs") {
            for (let i = 0; i < automation.data.ifs[ifType].length; i++) {
              const connectionIf = automation.data.ifs[ifType][i];

              let ifObj = {
                if_sensor: connectionIf.device,
                if_connect: connectionIf.online,
              };
              ifs.push({ connection: ifObj });
            }
          } else if (ifType == "output_ifs") {
            for (let i = 0; i < automation.data.ifs[ifType].length; i++) {
              const outputIf = automation.data.ifs[ifType][i];

              let ifObj = {
                if_controller: outputIf.device,
                if_output: outputIf.output,
              };
              ifs.push({ output: ifObj });
            }
          } else if (ifType == "rssi_ifs") {
            for (let i = 0; i < automation.data.ifs[ifType].length; i++) {
              const rssiIf = automation.data.ifs[ifType][i];
              // console.log("rssiIf: ", rssiIf);
              let ifObj = {
                if_sensor: rssiIf.device,
                if_signalType: rssiIf.type,
                if_strength: rssiIf.strength,
                if_gateway: rssiIf.gateway ?? null,
              };
              ifs.push({ rssi: ifObj });
            }
          } else if (ifType == "gateway_rssi_ifs") {
            for (let i = 0; i < automation.data.ifs[ifType].length; i++) {
              const rssiIf = automation.data.ifs[ifType][i];
              let ifObj = {
                if_gateway: rssiIf.gateway,
                if_bottom_threshold: rssiIf.bottom_threshold,
                if_top_threshold: rssiIf.top_threshold,
                devices: rssiIf.devices,
              };
              ifs.push({ gateway_rssi: ifObj });
            }
          } else if (ifType == "time_ifs") {
            for (let i = 0; i < automation.data.ifs[ifType].length; i++) {
              const timeIf = automation.data.ifs[ifType][i];
              if (timeIf.time) {
                let ifObj = {
                  time: "24/7",
                };
                ifs.push({ schedule: ifObj });
              } else {
                let days = [];
                timeIf.days.split(",").forEach((d) => {
                  days.push(d);
                });
                let ifObj = {
                  startTime: timeIf.start,
                  endTime: timeIf.end,
                  days: days,
                };
                ifs.push({ schedule: ifObj });
              }
            }
          }
        });

        for (let i = 0; i < automation.data.thens.length; i++) {
          let thenValue = automation.data.thens[i];
          if (thenValue.type == "msg") {
            let nots = [];
            thenValue.parameter.split(",").forEach((not) => {
              nots.push(not);
            });
            let thenObj = {
              msg: thenValue.value,
              not: nots,
            };
            thens.push({ then_notify: thenObj });
          } else if (thenValue.type == "device") {
            let thenObj = {
              then_action: thenValue.value,
              then_controller: thenValue.device,
            };
            thens.push(thenObj);
          }
        }

        for (let i = 0; i < automation.data.ends.length; i++) {
          let endValue = automation.data.ends[i];
          if (endValue.type == "msg") {
            let nots = [];
            endValue.parameter.split(",").forEach((not) => {
              nots.push(not);
            });
            let endObj = {
              msg: endValue.value,
              not: nots,
            };
            ends.push({ end_notify: endObj });
          } else if (endValue.type == "device") {
            let endObj = {
              end_action: endValue.value,
              end_controller: endValue.device,
            };
            ends.push(endObj);
          }
        }

        nextState[automation.uuid] = {
          name: automation.name,
          uuid: automation.uuid,
          status: automation.status,
          state: automation.state,
          delay_time: delay_time,
          automation_ifs: ifs,
          automation_thens: thens,
          automation_ends: ends,
        };
        // console.log("Automations22222222: ", state.automations);
      }
    }

    state.automations = nextState;
  },
  ["NEW_AUTOMATION"](state, data) {
    // console.log("NEW_AUTOMATION: ", data);
    const uuid =
      extractAutomationUuid(data.auto) || extractAutomationUuid(data.uuid);

    if (!uuid) {
      return;
    }

    const newState = { ...state.automations };
    const automation = {
      name: data.auto.autoName,
      status: true,
      state: 0,
      delay_time: data.auto.delay_time,
      uuid: uuid,
      automation_ifs: data.auto.ifs,
      automation_thens: data.auto.thens,
      automation_ends: data.auto.ends,
    };
    newState[uuid] = automation;
    state.automations = newState;
    localStorage.setItem("automations", JSON.stringify([data.auto]));
  },
  ["DELETE_AUTOMATION"](state, data) {
    let newState = { ...state.automations };
    delete newState[data.uuid];
    state.automations = newState;
  },
  ["TOGGLE_AUTOMATIONS"](state, auto) {
    state.automations[auto.uuid].status = auto.status;
    if (state.automations[auto.uuid].status) {
      this.dispatch("general/setAlert", {
        type: "success",
        msg: "auto-started",
      });
    } else {
      this.dispatch("general/setAlert", {
        type: "failed",
        msg: "auto-stopped",
      });
    }
  },
};

/**
 * Actions
 */
export const actions = {
  async getAutomations({ commit }) {
    await axios
      .get(URL)
      .then((res) => {
        commit("SET_AUTOMATIONS", res.data);
      })
      .catch((err) => {
        console.log("ERROR IS: ", err);
      });
  },
  async setAutomation({ commit }, auto) {
    await axios
      .post(URL + "create", auto)
      .then((res) => {
        // console.log("res.data", res.data, "res.data.data", res.data.data);
        // commit("NEW_AUTOMATION", { auto: auto, uuid: 0 });
        const responsePayload = getResponsePayload(res.data);
        const uuid = extractAutomationUuid(responsePayload);

        commit("NEW_AUTOMATION", {
          auto: {
            ...auto,
            uuid: uuid || auto.uuid,
          },
          uuid: uuid,
        });
        this.dispatch("general/setAlert", {
          type: "success",
          msg: "auto-create",
        });
      })
      .catch((err) => {
        console.log("ERROR IS: ", err);
        this.dispatch("general/setAlert", {
          type: "failed",
          msg: "oops",
        });
      });
  },
  async updateAutomation({ commit }, auto) {
    if (auto.uuid.uuid) {
      auto.uuid = JSON.parse(JSON.stringify(auto.uuid.uuid));
    }
    await axios
      .post(URL + "update", auto)
      .then(() => {
        commit("NEW_AUTOMATION", { auto: auto, uuid: auto.uuid });
        this.dispatch("general/setAlert", {
          type: "success",
          msg: "auto-update",
        });
      })
      .catch((err) => {
        console.log("ERROR IS: ", err);
        this.dispatch("general/setAlert", {
          type: "failed",
          msg: "oops",
        });
      });
  },
  async deleteAutomation({ commit }, uuid) {
    await axios
      .delete(URL + `${uuid}`)
      .then(async () => {
        await commit("DELETE_AUTOMATION", { uuid: uuid });
        this.dispatch("general/setAlert", {
          type: "success",
          msg: "auto-delete",
        });
      })
      .catch((err) => {
        console.log("ERROR IS: ", err);
        this.dispatch("general/setAlert", {
          type: "failed",
          msg: "oops",
        });
      });
  },
  async toggleAutomation({ commit }, auto) {
    await axios
      .post(URL + "toggle", { status: auto.status, uuid: auto.uuid })
      .then(() => {
        commit("TOGGLE_AUTOMATIONS", auto);
      })
      .catch((err) => {
        console.log("ERR", err);
      });
  },
};

/**
 * Getters
 */
export const getters = {
  automationsObj: (state) => state.automations,
  automation: (state) => (uuid) => state.automations[uuid],
};
